<template>
  <div>
    <v-card color="grey lighten-1" flat rounded="xl">
      <v-container class="pa-9">
        <v-row>
          <v-col
            v-for="(url, index) in cakeStore.data.content.url"
            :key="`ulr-${index}`"
            class="d-flex child-flex"
            cols="4"
          >
            <a :href="url" target="_blank">
              <v-img :src="url" aspect-ratio="1" class="rounded-lg" />
            </a>
          </v-col>
        </v-row>

        <v-list two-line color="transparent" class="px-6">
          <v-list-item class="mt-6">
            <v-list-item-content class="flex-grow-1">
              <v-list-item-subtitle> Pasta Tipi </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content style="flex-grow: 2 !important">
              <v-list-item-title class="text-h6">
                {{ cakeStore.cakeType }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="cakeStore.data.cake.cakeType === 0"></v-divider>
          <v-list-item v-if="cakeStore.data.cake.cakeType === 0">
            <v-list-item-content class="flex-grow-1">
              <v-list-item-subtitle> Pasta Şekli </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content style="flex-grow: 2 !important">
              <v-list-item-title>
                <v-chip outlined color="" label>
                  {{
                    cakeStore.cakeShape.find(
                      (item) => item.value === cakeStore.data.content.cakeShape
                    ).text
                  }}
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content class="flex-grow-1">
              <v-list-item-subtitle> Pasta Keki </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content style="flex-grow: 2 !important">
              <v-list-item-title>
                <v-chip outlined color="" label>
                  {{
                    cakeStore.cakeCake.find(
                      (item) => item.value === cakeStore.data.content.cakeCake
                    ).text
                  }}
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content class="flex-grow-1">
              <v-list-item-subtitle> Pasta Kremasi </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content style="flex-grow: 2 !important">
              <v-list-item-title>
                <v-chip outlined color="" label>
                  {{
                    cakeStore.cakeCream.find(
                      (item) => item.value === cakeStore.data.content.cakeCream
                    ).text
                  }}
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content class="flex-grow-1">
              <v-list-item-subtitle> Kişi Sayısı </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content style="flex-grow: 2 !important">
              <v-list-item-title>
                <v-chip label color="secondary">
                  {{ cakeStore.cakePeople }}
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content class="flex-grow-1">
              <v-list-item-subtitle> Teslimat Tarihi </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content style="flex-grow: 2 !important">
              <v-list-item-title>
                <v-chip label color="">
                  {{ cakeStore.deliveryDate | moment("DD MMMM dddd, YYYY") }}
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content class="flex-grow-1">
              <v-list-item-subtitle> Seçenekler </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content style="flex-grow: 2 !important">
              <v-list-item-title>
                <v-chip-group column>
                  <v-chip
                    v-for="(option, index) in cakeStore.data.content
                      .cakeOptions"
                    :key="index"
                    disabled
                    label
                    color="chip"
                    style="opacity: 1"
                  >
                    {{ option.text }}
                  </v-chip>
                </v-chip-group>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="cakeStore.data.cake.cakeType === 1"></v-divider>
          <v-list-item v-if="cakeStore.data.cake.cakeType === 1">
            <v-list-item-content class="flex-grow-1">
              <v-list-item-subtitle> Süsler </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content style="flex-grow: 2 !important">
              <v-list-item-title>
                <v-chip-group column>
                  <v-chip
                    v-for="(option, index) in cakeStore.data.content.cakeSus"
                    :key="index"
                    disabled
                    label
                    color="night"
                    style="opacity: 1"
                  >
                    {{
                      cakeStore.cakeSus.find((item) => item.slug === option)
                        .text
                    }}
                  </v-chip>
                </v-chip-group>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="cakeStore.data.content.orderNote"></v-divider>
          <v-list-item v-if="cakeStore.data.content.orderNote">
            <v-list-item-content class="flex-grow-1">
              <v-list-item-subtitle> İçerik Açıklaması </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content style="flex-grow: 2 !important">
              <v-list-item-title>{{
                cakeStore.data.content.orderNote
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="cakeStore.data.content.contentNote"></v-divider>
          <v-list-item v-if="cakeStore.data.content.contentNote">
            <v-list-item-content class="flex-grow-1">
              <v-list-item-subtitle> Sipariş Açıklaması </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content style="flex-grow: 2 !important">
              <v-list-item-title>{{
                cakeStore.data.content.contentNote
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-container>
    </v-card>
    <v-row align="center" class="my-9">
      <v-col md="6">
        <v-btn
          class="text-capitalize"
          plain
          x-large
          block
          rounded
          @click="backStep()"
          >Geri Git
        </v-btn>
      </v-col>
      <v-col md="6">
        <v-btn
          color="secondary"
          class="text-capitalize"
          depressed
          rounded
          x-large
          block
          :loading="cakeStore.loading"
          @click="cakeStore.save()"
        >
          {{ isEdit ? "Güncelle" : "Kaydet" }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "@vue/composition-api";

// Utils
import { postData } from "@utils";
import { useRouter } from "@core/utils";

import { useToast } from "vue-toastification/composition";

// Store
import { useCakeStore } from "@/stores/cake";

// Icon
import { mdiCalendar, mdiClock } from "@mdi/js";

export default {
  setup() {
    // Store
    const cakeStore = useCakeStore();
    const toast = useToast();
    const { route, router } = useRouter();
    const isEdit = ref(false);

    const backStep = () => {
      cakeStore.decrease();
    };

    onMounted(() => {
      if (route.value.params.item) {
        isEdit.value = true;
      }
    });

    const cakeOptionsText = (option) => {
      return cakeStore.cakeOptions.find((item) => item.slug === option).text;
    };

    watch(
      () => cakeStore.loading,
      (val) => {
        if (val == false) {
          router.push({ name: "order-tracking" });
        }
      }
    );
    return {
      cakeStore,
      backStep,
      isEdit,
      cakeOptionsText,
      icons: {
        mdiCalendar,
        mdiClock,
      },
    };
  },
};
</script>
